import React, { Component, Fragment } from 'react';
import { Grid, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { withRouter } from 'react-router';
import moment from 'moment';

import { DatePickerField } from 'Common/SemanticWrapper';
import { REVENUE_SUMMARY_REPORT_FORM_NAME } from 'Common/FormEnum';
import { RevenueSummaryReportFieldEnum as Fields } from 'Common/FieldEnum';
import { SelectField, CheckboxField } from 'Common/SemanticWrapper';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';

class RevenueSummaryReportFormContainer extends Component {
  feedingOptions = [
    { value: 0, label: 'Breakfast / Lunch / Other' },
    { value: 1, label: 'Supper' },
  ];

  componentDidUpdate(prevProps, prevState) {
    const { rates } = this.props;

    if (rates && prevProps.rates !== rates) {
      this.setDefaultReimbursementRate();
    }
  }

  setDefaultReimbursementRate = () => {
    let { rates, change } = this.props;
    if (rates && rates.length > 0) {
      rates = rates.sort(x => x.value).reverse();
      change(Fields.ReimbursementRateId, rates[0].value);
    }
  };

  render() {
    const { loading, formValues, rates } = this.props;
    return (
      <Fragment>
        <Form name={REVENUE_SUMMARY_REPORT_FORM_NAME}>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={8}>
                      <Field
                        name={Fields.ReimbursementRateId}
                        component={SelectField}
                        options={rates}
                        label={'Reimbursement Rates'}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <Grid.Row>
                  <Grid.Column className="input-group--btn-group">
                    <ReduxFormButtonGroup
                      label={'Meal Type'}
                      formName={REVENUE_SUMMARY_REPORT_FORM_NAME}
                      options={this.feedingOptions}
                      value={formValues[Fields.IsSupper]}
                      fieldName={Fields.IsSupper}
                      disabled={loading}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid columns={4}>
                  <Grid.Row style={{ paddingTop: '15px' }}>
                    <Grid.Column>
                      <Field
                        label={'From Date'}
                        name={Fields.FromDate}
                        component={DatePickerField}
                        type="text"
                        openToDate={moment()}
                        disabled={loading}
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <Field
                        label={'To Date'}
                        name={Fields.ToDate}
                        component={DatePickerField}
                        type="text"
                        openToDate={moment()}
                        disabled={loading}
                      />
                    </Grid.Column>
                    <Grid.Column style={{ paddingTop: '50px' }}>
                      <Field
                        label={'Show Daily Breakdown'}
                        name={Fields.ShowEachDay}
                        component={CheckboxField}
                        disabled={loading}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Fragment>
    );
  }
}

const validate = values => {
  const errors = {};

  if (!moment(values[Fields.FromDate]).isValid()) {
    errors[Fields.FromDate] = 'Enter a valid From Date.';
  }
  if (!values[Fields.FromDate]) {
    errors[Fields.FromDate] = 'From Date must be set.';
  }

  if (!moment(values[Fields.ToDate]).isValid()) {
    errors[Fields.ToDate] = 'Enter a valid To Date.';
  }
  if (!values[Fields.ToDate]) {
    errors[Fields.ToDate] = 'To Date must be set.';
  }

  if (
    moment(values[Fields.FromDate]).isValid() &&
    values[Fields.FromDate] &&
    moment(values[Fields.ToDate]).isValid() &&
    values[Fields.ToDate] &&
    moment(values[Fields.ToDate]).isBefore(values[Fields.FromDate])
  ) {
    errors[Fields.ToDate] =
      'To Date must be greater than or equal to From Date.';
  }
  if (!Fields.ReimbursementRateId) {
    errors[Fields.ReimbursementRateId] =
      'A Reimbursement Rate must be selected.';
  }

  return errors;
};

const mapStateToProps = state => {
  return {
    formValues: getFormValues(REVENUE_SUMMARY_REPORT_FORM_NAME)(state),
    loading: false,
  };
};

const RevenueSummaryReportForm = reduxForm({
  form: REVENUE_SUMMARY_REPORT_FORM_NAME,
  validate,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(withRouter(connect(mapStateToProps)(RevenueSummaryReportFormContainer)));

export { RevenueSummaryReportForm };



// WEBPACK FOOTER //
// ./src/pages/revenuesummaryreport/components/RevenueSummaryReportForm.js